import React from "react";
import { Routes, Route } from "react-router-dom";

import LoginPage from "../app/pages/LoginPage";
import LandingPage from "../app/pages/LandingPage";
import ProtectedRoute from "../app/auth/ProtectedRoute";
import HomePage from "../app/pages/HomePage";
import LeadPage from "../app/pages/LeadPage";
import UnsubmittedLeadsPage from "../app/pages/UnsubmittedLeadsPage";
import AdminProfilePage from "../app/pages/AdminProfilePage";
import SessionManagementPage from "../app/pages/SessionManagementPage";
import AdminManagementPage from "../pages/AdminManagementPage";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/home"
        element={
          <ProtectedRoute>
            <HomePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/lead"
        element={
          <ProtectedRoute>
            <LeadPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/unsubmitted-leads"
        element={
          <ProtectedRoute>
            <UnsubmittedLeadsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <AdminProfilePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin-management"
        element={
          <ProtectedRoute requireSuperAdmin={true}>
            <AdminManagementPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/session-management"
        element={
          <ProtectedRoute requireSuperAdmin={true}>
            <SessionManagementPage />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<LandingPage />} />
    </Routes>
  );
};

export default AppRoutes;
